export default __webpack_public_path__ + "3b92caaf1e4ce0d5f000657cf9a91fee.jpg";